export default __webpack_public_path__ + "static/media/1984.4da4bc36.png";